import { render, staticRenderFns } from "./MbeSwitch.vue?vue&type=template&id=44454796&scoped=true&"
import script from "./MbeSwitch.vue?vue&type=script&lang=ts&"
export * from "./MbeSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./MbeSwitch.vue?vue&type=style&index=0&id=44454796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44454796",
  null
  
)

export default component.exports